import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { channelApi } from '../utils/api';

const s = {
  label: { fontSize: 12, color: '#888', marginBottom: 6 } as React.CSSProperties,
  row: { display: 'flex', gap: 8, marginBottom: 16 } as React.CSSProperties,
  input: {
    flex: 1, padding: '7px 10px', fontSize: 13, border: '1px solid #e5e5e5',
    borderRadius: 5, fontFamily: 'monospace', color: '#111', background: '#fff',
    outline: 'none',
  } as React.CSSProperties,
  btn: (primary?: boolean) => ({
    padding: '7px 14px', fontSize: 13, borderRadius: 5, cursor: 'pointer',
    border: primary ? 'none' : '1px solid #e5e5e5',
    background: primary ? '#6441a5' : '#fff',
    color: primary ? '#fff' : '#555',
    whiteSpace: 'nowrap',
  } as React.CSSProperties),
  ghost: { fontSize: 12, color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 } as React.CSSProperties,
  note: { fontSize: 12, color: '#aaa', marginTop: 4 } as React.CSSProperties,
};

const WidgetInfo: React.FC<{ channelId: number }> = ({ channelId }) => {
  const [copied, setCopied] = useState(false);
  const queryClient = useQueryClient();

  const { data: widgetData } = useQuery({
    queryKey: ['widget-url', channelId],
    queryFn: () => channelApi.getWidgetUrl(channelId).then(res => res.data),
  });

  const regenerateMutation = useMutation({
    mutationFn: () => channelApi.regenerateWidgetToken(channelId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['widget-url', channelId] }),
  });

  const handleCopy = async () => {
    if (widgetData?.widget_url) {
      await navigator.clipboard.writeText(widgetData.widget_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleRegenerate = () => {
    if (window.confirm('Regenerate widget token? The current URL will stop working.')) {
      regenerateMutation.mutate();
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: 16, fontWeight: 600, color: '#111', marginBottom: 20 }}>Widget</h2>

      <div style={s.label}>OBS Browser Source URL</div>
      <div style={s.row}>
        <input
          style={s.input}
          value={widgetData?.widget_url ?? ''}
          readOnly
        />
        <button style={s.btn()} onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
        <button style={s.btn(true)} onClick={() => widgetData?.widget_url && window.open(widgetData.widget_url, '_blank')}>
          Preview
        </button>
      </div>

      <button style={s.ghost} onClick={handleRegenerate} disabled={regenerateMutation.isPending}>
        {regenerateMutation.isPending ? 'Regenerating…' : 'Regenerate token'}
      </button>
      <div style={s.note}>Use this if your current URL is compromised.</div>
    </div>
  );
};

export default WidgetInfo;
